<template>
  <div class="chart">
    <div class="flex md:pt-0 pt-0 pb-3 px-5 md:px-0">
      <h1 class="font-family-card pl-5">Current Day</h1>
    </div>
    <div class="flex justify-center">
      <div id="chartContainer" style="width: 550px; height: 270px;" class="mb-20"></div>
    </div>
  </div>
</template>

<script setup>
import CanvasJS from '@canvasjs/charts';
import { onMounted, watchEffect, ref } from 'vue';
import { defineProps } from 'vue';

const props = defineProps({
  cardDataincineration: Object,
});

const chartCanvas = ref(null);
const legendContainer = ref(null);

onMounted(() => {
  watchEffect(() => {
    const selectedData = props.cardDataincineration.currentDateIncinerationGraphData || [];

    // Use the received data to update the chart
    const labels = selectedData.map((district) => district.incineratedSite);
    const chartData = selectedData.map((district) => ({ y: district.weight, label: district.incineratedSite }));
    CanvasJS.addColorSet("greenShades",
      [
        '#66C2A5', '#FFFF00', '#A6D854', '#E78AC3', '#8DA0CB', '#FC8D62'
      ]);
    var chart = new CanvasJS.Chart("chartContainer", {
      title: {
        text: "",
      },
      colorSet: "greenShades",
      toolbar: {
        itemBackgroundColor: ['#66C2A5', '#FFFF00', '#A6D854', '#E78AC3', '#8DA0CB', '#FC8D62'],
      },
      data: [{
        toolTipContent: "<span style='\"'color: {color};'\"'>{label} - </span> {y}(kg)",
        type: "pie",
        yValueFormatString: "###",
         indexLabel: "{label}  - {y} kg",        
         dataPoints: chartData,
        borderColor: ['#66C2A5', '#FFFF00', '#A6D854', '#E78AC3', '#8DA0CB', '#FC8D62'], // You can add more colors:
      }],
    });

    chart.render();
  });
});
</script>
<style>
.canvasjs-chart-container {
    bottom: 7px;
}
a.canvasjs-chart-credit {
  display:none !important
}
</style>